var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-holder"},[_c('div',{staticClass:"stripe-card"},[_c('div',{ref:"card"}),_c('b-form-invalid-feedback',{attrs:{"force-show":!!_vm.error}},[_vm._v(_vm._s(_vm.error))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }